<!-- components/Grid.svelte -->
<script>
  export let columns = "1"; // Number of columns or CSS grid value
  export let gap = "1rem";
  export let responsive = true; // Enable responsive breakpoints
  export let align = "stretch"; // align-items value
  export let justify = "stretch"; // justify-items value

  let className = "";
  export { className as class };

  $: gridColumns = isNaN(parseInt(columns))
    ? columns
    : `repeat(${columns}, 1fr)`;

  $: gridStyle = `
    grid-template-columns: ${gridColumns};
    gap: ${gap};
    align-items: ${align};
    justify-items: ${justify};
  `;

  $: classes = `grid ${responsive ? "grid--responsive" : ""} ${className}`;
</script>

<div class={classes} style={gridStyle}>
  <slot />
</div>

<style lang="scss">
  .grid {
    display: grid;
    width: 100%;
  }

  .grid--responsive {
    /* Default responsive breakpoints */
    @media (max-width: 1200px) {
      &[style*="repeat(5"] {
        grid-template-columns: repeat(3, 1fr) !important;
      }
    }

    @media (max-width: 900px) {
      &[style*="repeat(5"] {
        grid-template-columns: repeat(2, 1fr) !important;
      }

      &[style*="repeat(4"] {
        grid-template-columns: repeat(2, 1fr) !important;
      }

      &[style*="repeat(3"] {
        grid-template-columns: repeat(2, 1fr) !important;
      }
    }

    @media (max-width: 600px) {
      &[style*="repeat("] {
        grid-template-columns: 1fr !important;
      }
    }
  }

  /* Specific responsive patterns for common use cases */
  :global(.info-cards) {
    @media (max-width: 900px) {
      grid-template-columns: repeat(2, 1fr) !important;
    }

    @media (max-width: 600px) {
      grid-template-columns: 1fr !important;
      gap: 1.5rem !important;
      margin-top: 2rem !important;
    }
  }

  :global(.who-cards) {
    @media (max-width: 1200px) {
      grid-template-columns: repeat(3, 1fr) !important;
    }

    @media (max-width: 900px) {
      grid-template-columns: repeat(2, 1fr) !important;
    }

    @media (max-width: 600px) {
      grid-template-columns: 1fr !important;
      gap: 1.5rem !important;
    }
  }
</style>
